export default __webpack_public_path__ + "static/media/footer_download_app2.ff518341.jpeg";